import { render, staticRenderFns } from "./packagesComplete.vue?vue&type=template&id=59a3b980&scoped=true&"
import script from "./packagesComplete.vue?vue&type=script&lang=js&"
export * from "./packagesComplete.vue?vue&type=script&lang=js&"
import style0 from "./packagesComplete.vue?vue&type=style&index=0&id=59a3b980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a3b980",
  null
  
)

export default component.exports